import React, { useEffect, useRef, useState } from "react";
import "./BlogForm.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { getAllsubSubject } from "../../../services/getAllSubSubject";
import { ImageLink } from "../../../constants";

const BlogForm = () => {
  const fileRef = useRef();

  const [files, setFiles] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);

  const [payload, setPayload] = useState({
    description: "",
    subject: "",
    deadline: null,
  });

  const [error, setError] = useState({});
  useEffect(() => {
    fetchSubjectData();
  }, []);

  const fetchSubjectData = async () => {
    try {
      const response = await getAllsubSubject();
      const option = response.data.map((data) => ({
        value: data._id,
        image: data.image,
        label: data.subSubjectName,
        parent: data?.subjectId?.questionSubject,
      }));
      setSubjectOptions(option);
    } catch (err) {
      console.error("Failed to fetch subjects:", err);
    }
  };
  const handleChange = (name, value) => {
    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));

    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleSubjectChange = (option) => {
    setSelectedSubject(option);
    handleChange("subject", option ? option.value : "");
  };

  const handleFiles = (selectedFiles) => {
    const fileArray = Array.from(selectedFiles).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setFiles((prev) => [...prev, ...fileArray]);
  };

  const removeFile = (index) => {
    const updated = [...files];
    URL.revokeObjectURL(updated[index].preview);
    updated.splice(index, 1);
    setFiles(updated);
  };
  const isFormValid =
    payload.description.trim() !== "" &&
    payload.subject !== "" &&
    payload.deadline !== null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newError = {};
    if (!payload.description) newError.description = "Description is required";
    if (!payload.subject) newError.subject = "Subject is required";
    if (!payload.deadline) newError.deadline = "Deadline is required";

    if (Object.keys(newError).length > 0) {
      setError(newError);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("description", payload.description);
      formData.append("subject", payload.subject);
      formData.append("deadline", payload.deadline.toISOString());

      files.forEach((item) => {
        formData.append("files", item.file);
      });

      const res = await fetch("/api/assignment", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      setPayload({
        description: "",
        subject: "",
        deadline: null,
      });
      setSelectedSubject(null);
      setFiles([]);
      setError({});
    } catch (err) {
      console.error("Submission error:", err);
    }
  };
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      fontSize: "13px",
      zIndex:10,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 8px",
      zIndex:10,
    }),
    input: (base) => ({
      ...base,
      fontSize: "13px",
      zIndex:10,
    }),
  };

  return (
    <div className="assignment-card">
      <div className="card-header">
        <h2>Stuck With Your Assignment?</h2>
        <p>Get Your Assignment Done From Our Expert Writers</p>
        <button className="reward-btn">$20 Reward Upon Registration</button>
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <p className="order-text">Place your order here</p>
          <textarea
            placeholder="Type your question here or add files"
            rows={4}
            value={payload.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />
          {error.description && <p className="error">{error.description}</p>}
          <div
            className="upload-box"
            onClick={() => fileRef.current.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleFiles(e.dataTransfer.files);
            }}
          >
            Drop Your Files or <span>Browse +</span>
          </div>

          <input
            type="file"
            multiple
            ref={fileRef}
            style={{ display: "none" }}
            onChange={(e) => handleFiles(e.target.files)}
          />
          <div className="preview-container">
            {files.map((item, index) => (
              <div key={index} className="preview-item">
                {item.file.type.startsWith("image/") ? (
                  <img src={item.preview} alt="preview" />
                ) : (
                  <p>{item.file.name}</p>
                )}
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => removeFile(index)}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>

        

          <div className="mt-3">
            <Select
              value={selectedSubject}
              onChange={handleSubjectChange}
              options={subjectOptions}
              placeholder="Select your subject"
              name="subject"
              styles={customStyles}
              className="question-select mt-2 select-subject text-start"
              formatOptionLabel={(option) => (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <img
                    src={ImageLink(option.image)}
                    alt={option.label}
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "6px",
                      objectFit: "cover",
                    }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", fontSize: "14px" }}>
                    <span>{option.label}</span>
                    <small style={{ color: "#777", fontSize: "10px" }}>
                      {option.parent}
                    </small>
                  </div>
                </div>
              )}
            />
            {error.subject && <p className="error">{error.subject}</p>}
          </div>
          
            <div className="mt-3">
            <DatePicker
              selected={payload.deadline}
              onChange={(date) => handleChange("deadline", date)}
              minDate={new Date()}
              dateFormat="dd MMM yyyy"
              className="date-picker-input"
              calendarClassName="dp-calendar"
              popperClassName="dp-popper"
              placeholderText="Set Deadline"
            />
            {error.deadline && <p className="error">{error.deadline}</p>}
          </div>
          <button type="submit" className="submit-btn" disabled={!isFormValid}>
            Get Assignment Help
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlogForm;